module.exports = __webpack_public_path__ + "img/logo-dark.6a975123.png";